/**
 * DeleteConfirmDialog Component (Chat)
 * Simple confirmation dialog for deleting conversations
 *
 * Migrated to BaseDialog pattern (Phase 3.2)
 */

import DeleteIcon from '@mui/icons-material/Delete';
import { Button, Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { BaseDialog } from '../ui/BaseDialog';

interface DeleteConfirmDialogProps {
  open: boolean;
  deleting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const DeleteConfirmDialog: React.FC<DeleteConfirmDialogProps> = ({
  open,
  deleting,
  onClose,
  onConfirm
}) => {
  const { t } = useTranslation();

  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      title={t('chat.deleteConfirm.title')}
      maxWidth="xs"
      loading={deleting}
      actions={
        <>
          <Button onClick={onClose} disabled={deleting}>
            {t('chat.deleteConfirm.cancel')}
          </Button>
          <Button
            onClick={onConfirm}
            color="error"
            variant="contained"
            startIcon={<DeleteIcon />}
          >
            {t('chat.deleteConfirm.confirm')}
          </Button>
        </>
      }
    >
      <Box sx={{ pb: 1 }}>
        <Typography variant="body1">
          {t('chat.deleteConfirm.message')}
        </Typography>
      </Box>
    </BaseDialog>
  );
};